import { render } from "./Technology.vue?vue&type=template&id=d2b3be46"
import script from "./Technology.vue?vue&type=script&lang=js"
export * from "./Technology.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__